// extracted by mini-css-extract-plugin
module.exports = {"logo_dafeng":"logo_dafeng-qzH-JBLw"};